<template>
  <div class="appraiser">
    <el-row :gutter="10">
      <el-col
        :xs="24"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
        v-for="(item,index) in data"
        :key="index"
        style="margin-top:10px;"
      >
        <el-card shadow="always">
          <div slot="header">
            <p class="card_title">
              <span>{{item.name}}</span>
            </p>
          </div>
          <div class="card_content">
            <ul>
              <li class="card_content_li" style="width: 100%;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;text-align: left;">
                <span
                  class="icon common_backgroundImg"
                  :style="'background-image:url(' + iconList[0]  + ')'"
                ></span>
                {{item.provinceName == item.cityName ?item.provinceName:item.provinceName+item.cityName}}{{item.districtName}}{{item.detail_addr}}
              </li>
              <li class="card_content_li">
                <span
                  class="icon common_backgroundImg"
                  :style="'background-image:url(' + iconList[1]  + ')'"
                ></span>
                报名时间：{{item.apply_start_time|dateformat('YYYY-MM-DD')}} 至 {{item.apply_end_time|dateformat('YYYY-MM-DD')}}
              </li>
            </ul>
            <p class="line"></p>
            <p class="common_display card_bottom">
              <!-- <span class="card_bottom_left">￥{{item.testPrice}}</span> -->
              <span class="card_bottom_left"></span>
              <span>
                <el-button size="mini" type="danger" @click="signUp(item)">报 名</el-button>
              </span>
            </p>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <role-permissions :dialogVisible="dialogVisible" @changeDialogVisible="changeDialogVisible" roleName="考评员"/>
  </div>
</template>

<script>
import { GetExaminerClassList2 } from "@/api/admin/common.js";
import { mapGetters } from "vuex";
import rolePermissions from "@/views/admin/components/rolePermissions.vue";
export default {
  name: "",
  props: {
    title: String
  },
  components: {
    rolePermissions
  },
  data() {
    return {
      data: [],
      iconList: ["/image/new/icon_place.png", "/image/new/icon_time.png"],
      paging: {
        limit: 3,
        page: 1
      },
      dialogVisible: false,
    };
  },
  computed: {
      ...mapGetters(["userRole","levels"])
  },
  created(){
    this.getList()
  },
  methods: {
    getList() {
      // 考评员列表
      GetExaminerClassList2(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
        }
      });
    },
    //报名
    signUp(item) {
        if (this.userRole == 2) {
          this.$router.push({
            path: "/evaluationStaffTraining/evaluationStaffTrainingDetail",
            query: {id:item.id}
          });
        }else{
            this.dialogVisible = true;
        }
    },
    changeDialogVisible(val){
        this.dialogVisible = val;
      },
    //详情
    examDatail(id){
        this.$router.push({
            path: "/evaluationStaffTraining/evaluationStaffTrainingDetail",
            query: {id}
        });
    }
  }
};
</script>

<style lang="less">
.appraiser {
  margin-top: 10px;
  .el-card__body {
    padding: 5px;
  }
  .el-card__header {
    padding: 0px;
    color: #ffffff;
    .card_title {
      width: 100%;
      background: #c96160;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
      span {
        display: block;
        padding: 20px;
        color: #FFFFFF;
        width: 90%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
      }
    }
  }
  .card_content {
    padding: 5px 10px;
    .icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      position: relative;
      top: 4px;
    }
    .card_content_li,
    .card_bottom {
      margin: 10px 0px;
    }
    .line {
      border-bottom: 1px solid #c4c4c4;
    }
    .card_bottom_left {
      line-height: 32px;
      color: #f56c6c;
    }
  }
}
</style>
